export function polyfillRequestIdleCallback() {
    window.requestIdleCallback =
        window.requestIdleCallback ||
        function (cb) {
            const start = Date.now();
            return setTimeout(function () {
                cb({
                    didTimeout: false,
                    timeRemaining() {
                        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
                        return Math.max(0, 50 - (Date.now() - start));
                    },
                });
            }, 1);
        };

    window.cancelIdleCallback =
        window.cancelIdleCallback ||
        function (id) {
            clearTimeout(id);
        };
}
